import { render, staticRenderFns } from "./MitMyReqeustsPage.vue?vue&type=template&id=36ad38af&scoped=true"
import script from "./MitMyReqeustsPage.vue?vue&type=script&lang=js"
export * from "./MitMyReqeustsPage.vue?vue&type=script&lang=js"
import style0 from "./MitMyReqeustsPage.vue?vue&type=style&index=0&id=36ad38af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ad38af",
  null
  
)

export default component.exports